export default "__VITE_ASSET__DYjR4g$v__"